import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function farmHeaders(token) {
  return { Authorization: `Bearer ${token}` };
}

export async function farmGet(path, token, params) {
  const res = await axios.get(`${API_URL}/api${path}`, {
    headers: farmHeaders(token),
    params,
  });
  return res.data;
}

export async function farmPost(path, token, body, isForm = false) {
  const headers = farmHeaders(token);
  if (isForm) {
    // FormData: non forzare Content-Type
  } else {
    headers["Content-Type"] = "application/json";
  }
  const res = await axios.post(`${API_URL}/api${path}`, body, { headers });
  return res.data;
}

export async function farmPut(path, token, body) {
  const res = await axios.put(`${API_URL}/api${path}`, body, {
    headers: { ...farmHeaders(token), "Content-Type": "application/json" },
  });
  return res.data;
}

export async function farmPatch(path, token, body) {
  const res = await axios.patch(`${API_URL}/api${path}`, body, {
    headers: { ...farmHeaders(token), "Content-Type": "application/json" },
  });
  return res.data;
}

export async function farmDelete(path, token) {
  const res = await axios.delete(`${API_URL}/api${path}`, {
    headers: farmHeaders(token),
  });
  return res.data;
}

export const STATO_CONTROLLO_LABELS = {
  complete: { label: "Complete", className: "bg-emerald-50 text-emerald-700 border-emerald-100" },
  parziali: { label: "Parziali", className: "bg-amber-50 text-amber-700 border-amber-100" },
  nessuna_ricetta: { label: "Nessuna ricetta", className: "bg-rose-50 text-rose-700 border-rose-100" },
  scadute: { label: "Scadute", className: "bg-slate-100 text-slate-700 border-slate-200" },
};

export const STATO_ESSENZIALE_LABELS = {
  ricetta_mancante: { label: "Ricetta mancante", className: "bg-rose-50 text-rose-700 border-rose-100" },
  ricevuta: { label: "Ricevuta", className: "bg-sky-50 text-sky-700 border-sky-100" },
  da_verificare: { label: "Da verificare", className: "bg-amber-50 text-amber-700 border-amber-100" },
  copertura_completa: { label: "Copertura completa", className: "bg-emerald-50 text-emerald-700 border-emerald-100" },
  copertura_parziale: { label: "Copertura parziale", className: "bg-amber-50 text-amber-700 border-amber-100" },
  illeggibile: { label: "Illeggibile", className: "bg-rose-50 text-rose-700 border-rose-100" },
  da_integrare: { label: "Da integrare", className: "bg-orange-50 text-orange-700 border-orange-100" },
};

export const COPERTURA_FARMACO_LABELS = {
  coperto: "Coperto",
  non_coperto: "Non coperto",
  copertura_parziale: "Copertura parziale",
  possibile_equivalente: "Possibile equivalente",
  da_verificare: "Da verificare",
  documento_illeggibile: "Documento illeggibile",
  documentazione_aggiuntiva_richiesta: "Documentazione aggiuntiva richiesta",
};

export const STATO_RICHIESTA_LABELS = {
  da_gestire: "Da gestire",
  in_attesa_medico: "In attesa medico",
  invio_programmato: "Invio programmato",
  inviata_medico: "Inviata al medico",
  ricette_ricevute: "Ricette ricevute",
  chiusa: "Pratica conclusa",
  scaduta: "Scaduta",
};

export const STATO_ORDINE_LABELS = {
  bozza: { label: "Bozza", className: "bg-slate-50 text-slate-600 border-slate-200" },
  inviato: { label: "Inviato", className: "bg-sky-50 text-sky-700 border-sky-100" },
  ricevuto: { label: "Ricevuto", className: "bg-blue-50 text-blue-700 border-blue-100" },
  confermato: { label: "Confermato", className: "bg-emerald-50 text-emerald-700 border-emerald-100" },
  parziale: { label: "Parziale", className: "bg-amber-50 text-amber-700 border-amber-100" },
  rifiutato: { label: "Rifiutato", className: "bg-rose-50 text-rose-700 border-rose-100" },
  pronta: { label: "Pronta", className: "bg-emerald-50 text-emerald-700 border-emerald-100" },
  in_preparazione: { label: "In preparazione", className: "bg-violet-50 text-violet-700 border-violet-100" },
  pronto: { label: "Pronto", className: "bg-cyan-50 text-cyan-700 border-cyan-100" },
  consegnato: { label: "Consegnato", className: "bg-slate-100 text-slate-700 border-slate-200" },
  annullato: { label: "Annullato", className: "bg-slate-50 text-slate-500 border-slate-200" },
};

export const URGENZA_ORDINE_LABELS = {
  normale: "Normale",
  urgente: "Urgente",
  critica: "Critica",
};

export const ALERT_SCORTA_LABELS = {
  scorta_bassa: { label: "Scorta bassa", className: "bg-rose-50 text-rose-700 border-rose-100" },
  da_verificare: { label: "Da verificare", className: "bg-amber-50 text-amber-700 border-amber-100" },
  quantita_discordanti: { label: "Quantità discordanti", className: "bg-orange-50 text-orange-700 border-orange-100" },
  prodotto_ordinato: { label: "Prodotto ordinato", className: "bg-sky-50 text-sky-700 border-sky-100" },
  prodotto_in_consegna: { label: "In consegna", className: "bg-violet-50 text-violet-700 border-violet-100" },
  copertura_insufficiente: { label: "Copertura insufficiente", className: "bg-rose-50 text-rose-700 border-rose-100" },
  copertura_a_rischio: { label: "Copertura a rischio", className: "bg-amber-50 text-amber-700 border-amber-100" },
};

export const STATO_CONSEGNA_LABELS = {
  da_pianificare: { label: "Da pianificare", className: "bg-slate-50 text-slate-600 border-slate-200" },
  pianificata: { label: "Pianificata", className: "bg-sky-50 text-sky-700 border-sky-100" },
  pronta: { label: "Pronta", className: "bg-emerald-50 text-emerald-700 border-emerald-100" },
  in_preparazione: { label: "In preparazione", className: "bg-violet-50 text-violet-700 border-violet-100" },
  in_consegna: { label: "In consegna", className: "bg-amber-50 text-amber-700 border-amber-100" },
  consegnata: { label: "Consegnata", className: "bg-emerald-50 text-emerald-700 border-emerald-100" },
  parziale: { label: "Parziale", className: "bg-orange-50 text-orange-700 border-orange-100" },
  problema: { label: "Problema", className: "bg-rose-50 text-rose-700 border-rose-100" },
  riprogrammata: { label: "Riprogrammata", className: "bg-slate-100 text-slate-700 border-slate-200" },
};

export const FASCIA_CONSEGNA_LABELS = {
  mattina: "Mattina",
  pomeriggio: "Pomeriggio",
  sera: "Sera",
  altro: "Altro",
};

export const STATO_FATTURA_LABELS = {
  bozza: { label: "Bozza", className: "bg-slate-50 text-slate-600 border-slate-200" },
  pubblicata: { label: "Pubblicata", className: "bg-sky-50 text-sky-700 border-sky-100" },
  visualizzata: { label: "Visualizzata", className: "bg-violet-50 text-violet-700 border-violet-100" },
  da_pagare: { label: "Da pagare", className: "bg-amber-50 text-amber-700 border-amber-100" },
  pagata: { label: "Pagata", className: "bg-emerald-50 text-emerald-700 border-emerald-100" },
  contestata: { label: "Contestata", className: "bg-rose-50 text-rose-700 border-rose-100" },
  archiviata: { label: "Archiviata", className: "bg-slate-100 text-slate-700 border-slate-200" },
};
